var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.vision
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page vision-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_vision" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "18px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.vision.hospitalName
                      ? _vm.model.vision.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "22px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.vision.reportName
                        ? _vm.model.vision.reportName
                        : "屈光筛查报告"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "margin-left": "15px",
                  "margin-right": "8px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.schoolName
                                  ? _vm.model.vision.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.gradeName
                                  ? _vm.model.vision.gradeName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.className
                                  ? _vm.model.vision.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("编号："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.barCode
                                  ? _vm.model.vision.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("筛查时间："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.screeningTime
                                  ? _vm.model.vision.screeningTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.name
                                  ? _vm.model.vision.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.sex ? _vm.model.vision.sex : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.age ? _vm.model.vision.age : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c("div", {
              staticStyle: { "border-bottom": "1px solid rgb(14, 14, 14)" },
            }),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-top": "10px",
                  "margin-left": "15px",
                  "padding-top": "20px",
                  "padding-bottom": "20px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _vm._m(0),
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "25px", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            color: "rgb(66, 100, 216)",
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [_vm._v("右眼")]
                      ),
                      _vm._m(1),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.rightEyeSBallDiameter
                                  ? _vm.model.vision.rightEyeSBallDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.sballNormalRange
                                  ? _vm.model.vision.sballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                            "border-right": "2px solid rgb(0, 0, 0)",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.rightEyeSBallDiameterIndication
                                  ? _vm.model.vision
                                      .rightEyeSBallDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "25px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            color: "rgb(66, 100, 216)",
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [_vm._v("左眼")]
                      ),
                      _vm._m(2),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.leftEyeSBallDiameter
                                  ? _vm.model.vision.leftEyeSBallDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.sballNormalRange
                                  ? _vm.model.vision.sballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.leftEyeSBallDiameterIndication
                                  ? _vm.model.vision
                                      .leftEyeSBallDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "25px", border: "none" } },
                    [
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _vm._m(3),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.rightEyeCColumnDiameter
                                  ? _vm.model.vision.rightEyeCColumnDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.cballNormalRange
                                  ? _vm.model.vision.cballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                            "border-right": "2px solid rgb(0, 0, 0)",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision
                                  .rightEyeCColumnDiameterIndication
                                  ? _vm.model.vision
                                      .rightEyeCColumnDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "25px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _vm._m(4),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.leftEyeCColumnDiameter
                                  ? _vm.model.vision.leftEyeCColumnDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision.cballNormalRange
                                  ? _vm.model.vision.cballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.vision
                                  .leftEyeCColumnDiameterIndication
                                  ? _vm.model.vision
                                      .leftEyeCColumnDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "left",
                  "margin-top": "10px",
                  "padding-top": "10px",
                  "padding-left": "15px",
                  "padding-bottom": "10px",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                },
              },
              [
                _vm._v("\n      筛查设备："),
                _c("span", [
                  _vm._v(_vm._s(_vm.model.vision.screeningEquipment)),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  "margin-left": "15px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(5),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.vision.screeningSummary
                                    ? _vm.model.vision.screeningSummary
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(6),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.vision.recommendations
                                    ? _vm.model.vision.recommendations
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "refractive_childrenVisionCareTips",
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(7),
                          _vm._l(
                            _vm.model.vision.childrenVisionCareTips,
                            function (item, index) {
                              return _c(
                                "div",
                                { staticStyle: { "min-height": "20px" } },
                                [_c("p", [_vm._v(_vm._s(item ? item : ""))])]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      { staticStyle: { "line-height": "25px", border: "none" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("眼睛")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("指标")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("检查结果")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("范围")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
              "border-right": "2px solid rgb(0, 0, 0)",
            },
          },
          [_vm._v("指示")]
        ),
        _c("td", {
          staticStyle: {
            width: "25px",
            "border-collapse": "collapse",
            border: "none",
          },
        }),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("眼睛")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("指标")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("检查结果")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("范围")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("指示")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("s球径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("s球径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("c柱径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("c柱径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【筛查小结】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【建议】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【儿童视力保健提示】"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }